// @noflow
import { FrequencyContainer, Main, ScheduleContainer } from './style';

import { FrequencySelector } from '../';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Schedule } from '~/components/widgets';

RecipeSchedule.propTypes = {
    isScheduled: PropTypes.bool.isRequired,
    scheduleComponentId: PropTypes.string.isRequired,
    toggleScheduleState: PropTypes.func.isRequired
};

export default function RecipeSchedule({ isScheduled, scheduleComponentId, toggleScheduleState }) {
    return (
        <Main>
            <FrequencyContainer>
                <FrequencySelector handleChange={toggleScheduleState} isScheduled={isScheduled} />
            </FrequencyContainer>
            <ScheduleContainer show={isScheduled}>
                <Schedule componentId={scheduleComponentId} />
            </ScheduleContainer>
        </Main>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-schedule/component.js